export const statusKeys = {
    monitors: ['monitors'],
};
